import { log } from '@/shared/utils/log';

import { EncryptionType } from '../../secure-json/core/crypto-core/types';
import { CollectionName } from '../../sj-orm/constants';
import { SJDatabase } from '../../sj-orm/core';

export const updatePublicKeysInDtos = async ({
  encryptionType,
  sjDb,
  dtoIdsMap,
  publicKey,
}: {
  encryptionType: EncryptionType;
  sjDb: SJDatabase;
  dtoIdsMap: Map<CollectionName, string[]>;
  publicKey: string;
}) => {
  const updatePublicKeyPromises: Promise<boolean>[] = [];

  dtoIdsMap.forEach((dtoIds, collectionName) => {
    const collection = sjDb.collections[collectionName];

    if (!collection) {
      return;
    }

    dtoIds.forEach((dtoId) => {
      log.info('[col] putPublicKey', collection);

      const updatePublicKeyPromise = collection.putPublicKey(
        dtoId,
        publicKey,
        // TODO crypto remove this hack for different encryption (CO+FM)
        encryptionType,
      );

      updatePublicKeyPromises.push(updatePublicKeyPromise);
    });
  });

  await Promise.all(updatePublicKeyPromises);
};
